/**
 * @generated SignedSource<<30d9669032fd278cd20117754f84b596>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateXeroVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createXeroVerificationKeyMutation$variables = {
  input: CreateXeroVerificationKeyInput;
};
export type createXeroVerificationKeyMutation$data = {
  readonly createXeroVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createXeroVerificationKeyMutation = {
  variables: createXeroVerificationKeyMutation$variables;
  response: createXeroVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateXeroVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createXeroVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createXeroVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createXeroVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ab0d79ae5d7ba6e56cd40db8b90561c9",
    "id": null,
    "metadata": {},
    "name": "createXeroVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createXeroVerificationKeyMutation(\n  $input: CreateXeroVerificationKeyInput!\n) {\n  createXeroVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "b956d39804506461eb90c404cfda02cd";

export default node;
